const sx = {
  flash: {
    display: 'none',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    opacity: 1,
    animation: 'flash 0.3s ease-out',
    zIndex: 1300,

    '&.flash': {
      display: 'block',
    },

    '@keyframes flash': {
      '0%': { opacity: 1 },
      '100%': { opacity: 0 },
    },
  },
  img: (previewSize: string) => ({
    width: previewSize,
    height: previewSize,
    position: 'absolute',
    bottom: '20px',
    left: '20px',
    borderRadius: '8px',
    cursor: 'pointer',
    objectFit: 'cover',
    border: '1px solid rgba(145, 158, 171, 0.32)',
    backgroundColor: 'black',

    '&:hover': {
      border: '1px solid rgba(145, 158, 171, 0.5)',
    }
  }),
};

export default sx;